import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

const getFilesFromEvent = (e: DragEvent | ClipboardEvent): FileList | undefined => {
	if ('dataTransfer' in e) {
		return e.dataTransfer?.files;
	}

	if ('clipboardData' in e) {
		return e.clipboardData?.files;
	}

	return undefined;
};

const isTextPasteEvent = (e: ClipboardEvent) => {
	return !!e.clipboardData?.getData?.('Text');
};

const byExtension = (exts: string[]) => (file: File) => exts.some((ext) => file.type.includes(ext));

const parseImageFromEvent = (e: ClipboardEvent | DragEvent) => {
	if (!e || isTextPasteEvent(e as any)) {
		return;
	}

	if (e.cancelable) {
		e.preventDefault();
	}

	const files = getFilesFromEvent(e);

	if (!files || !files.length) {
		return;
	}

	return [...files].filter(byExtension(['jpg', 'jpeg', 'png', 'gif']))[0];
};

interface UploadImageOptions {
	onUploadFile: (file: File) => Promise<string>;
}

export const UploadImage = Extension.create<UploadImageOptions>({
	name: 'FileDrop',

	addOptions() {
		return {
			onUploadFile: () => Promise.resolve(''),
		};
	},

	addProseMirrorPlugins() {
		return [
			new Plugin({
				key: new PluginKey('FileDrop'),

				props: {
					handleDOMEvents: {
						drop: (view, e) => {
							const { to } = view.state.selection;
							const file = parseImageFromEvent(e);

							if (file) {
								this.options.onUploadFile(file).then((url) => {
									this.editor.commands.insertContentAt(to, [
										{
											type: 'image',
											attrs: {
												src: url,
											},
										},
										{
											type: 'paragraph',
										},
									]);
								});
							}
						},

						paste: (view, e) => {
							const { to } = view.state.selection;
							const file = parseImageFromEvent(e);

							if (file) {
								this.options.onUploadFile(file).then((url) => {
									this.editor.commands.insertContentAt(to, [
										{
											type: 'image',
											attrs: {
												src: url,
											},
										},
										{
											type: 'paragraph',
										},
									]);
								});
							}
						},
					},
				},
			}),
		];
	},
});
